import * as Lucide from "lucide-react";

export const Icon = ({ name, className }) => {
  const Cmp = Lucide[name] || Lucide.Check;
  return <Cmp className={className} aria-hidden="true" />;
};

export default Icon;
